/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Error utilities for workflow mappers.
 * Aligns with ERROR_HANDLING_BEST_PRACTICES: normalize thrown values and extract
 * response/body for Azure/API parsing.
 */

/** Normalize unknown thrown value to Error for consistent handling. */
export const normalizeError = (err: unknown, fallbackMessage: string): Error => {
  return err instanceof Error ? err : new Error(String(err ?? fallbackMessage));
}

/** Extract response/body from API-style errors for Azure/API parsing. */
export const getResponseFromError = (err: unknown): unknown => {
  const error = err as { response?: unknown; body?: unknown };
  return error?.response ?? error?.body;
}
